import removeDiacritics from "./remove-diacritics";

/**
 * Removes optional LOINC- at beginning of code.
 * Loinc codes in BioExamObservation and BioExamOrder are stored without the `LOINC-` prefix.
 * This util is useful to pass codes from classic Sêmeia classes to thoses classes.
 */
export default function parameterize(word: string | null | undefined): string {
  if (word == null || word == undefined) return "";

  return removeDiacritics(word)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-");
}
